import { paths } from './routes';

export const providerAllowedRoutes: ReadonlySet<string> = new Set([
  paths.hlx.settings,
  paths.hlx.calendar,
  paths.hlx.jobOpportunities,
  paths.hlx.serviceOpportunities,
  paths.hlx.listings,
  paths.hlx.myServices,
  paths.hlx.contracts,
  // [MCV-1724] The header ? is on every role's bar, and its target is shared by all of them.
  // Without this a provider's click is bounced across hosts to the vault.
  paths.hlx.faq,
]);

export const normalizeRoutePathname = (pathname: string): string => {
  if (pathname === '/') return pathname;
  return pathname.replace(/\/+$/, '');
};

export const isProviderAllowedRoute = (pathname: string): boolean =>
  providerAllowedRoutes.has(normalizeRoutePathname(pathname));
